<div class="info-unavailable-container">
  <h1 class="info-not-available-header">{{orderUnavailableHeader}}</h1>
  <p>{{orderUnavailableBody}}</p>
</div>
